import React, { useEffect } from 'react';
import './SplashScreen.css';

const SplashScreen = ({ onComplete }) => {
  useEffect(() => {
    // Determine the duration of the splash screen.
    // Ensure this matches or slightly exceeds the duration of your splash-video.mp4.
    // For example, if it's a 3-second video, wait 3500ms total.
    const timer = setTimeout(() => {
      onComplete();
    }, 4500); // 4.5 seconds fallback

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className="splash-screen-container">
      <video
        autoPlay
        muted
        playsInline
        onEnded={onComplete}
        className="splash-video"
      >
        <source src="/splash-video.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default SplashScreen;